// CORE
import { NgModule } from "@angular/core";

// PIPES
import { FiltroPipe } from "./filtro.pipe";
import { PaginadorPipe } from "./paginador.pipe";
import { TipoPersonaNamePipe } from "./tipoPersonaName.pipe";
import { SourcesDatePipe } from "./sources-date.pipe";
import { FechaTimestampPipe } from "./fecha-timestamp.pipe";
import { UnderscoreWrapPipe } from "./underscore-wrap.pipe";
import { DatePipe } from "@angular/common";

const PIPES = [
  FiltroPipe,
  PaginadorPipe,
  TipoPersonaNamePipe,
  SourcesDatePipe,
  FechaTimestampPipe,
];

@NgModule({
  declarations: PIPES,
  imports: [UnderscoreWrapPipe],
  exports: [...PIPES, UnderscoreWrapPipe],
  providers: [DatePipe],
})
export class PipesModule { }
